import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";

import Profile from "./auth/profile/reducer";


// Users
import AddUser from "./users/reducer";

// Items
import Item from "./items/reducer";

// Equipments
import Equipment from "./equipments/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Profile,
  // AddUser
  AddUser,
  
  Item,
  Equipment,
});

export default rootReducer;
